import {
  change,
  Field,
  formValueSelector,
  reduxForm,
  reset,
} from 'redux-form';
import {
  deletePayerActivityCode, getAppointmentTypeForPayer, getExcludedServiceCodesFromActivity, getPayerActivityCptCodes,
} from '../../actions/index';
import { alertConfirmation, showNormalizedRate, showWarningMessage, AMEGO, IAT, TIIBA, CWO, ADAMANTSERVICES, SOAR, AMEGOFL, VIP, EBS } from '../../../../actions/utilAction';
import {
  renderAutoCompleteSingleSelectForColor,
} from '../../../../components/reduxFields';
import ActivityServiceCodeModal from './activityServiceCodeModal';
import Alert from 'react-s-alert';
import classNames from 'classnames';
import { connect } from 'react-redux';
import PaginatorCustom from '../../../../components/paginationCustom';
import RaisedButton from 'material-ui/RaisedButton';
import React from 'react';
import SortingCustom from '../../../../components/SortingCustom';
import SubString from 'add-ellipsis';
import validate from '../validate';
import Tooltip from '../../../../components/Tooltip';

class PayerActivityServiceCodes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      selectedActivityId: null,
      payerServiceCodeId: null,
      payerServiceCodeName: null,
      payerActivityServiceCodeId: null,
      noteTypeId: props.noteTypeId,
    };

    this.filter = {
      sort_Column: 'id',
      sort_Order: 'asc',
      searchText: '',
    };

    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.setSortColumn = this.setSortColumn.bind(this);
    this.handleResetButton = this.handleResetButton.bind(this);
    this.handleCancelActivity = this.handleCancelActivity.bind(this);
  }

  loadData(page_number) {
    let searchObj = {
      sort_fields: this.filter.sort_Column || 'id',
      sort_order: this.filter.sort_order || 'desc',
      contain_filters: { PayerId: this.props.payerId,
        ActivityId: this.state.selectedActivityId,
        SearchText: this.filter.searchText },
      pageNumber: page_number ? page_number : 1,
    };
    this.props.getPayerActivityCptCodes(searchObj);
    this.props.getExcludedServiceCodesFromActivity(this.props.payerId, this.state.selectedActivityId);
  }


  componentWillMount() {
    this.setState({
      selectedActivityId: this.props.payerActivityId,
    }, () => {
      if (this.state.selectedActivityId) {
        this.loadData();
      }
    });
    this.props.getAppointmentTypeForPayer(this.props.payerId);
  }

    handleOpen = () => {
      Alert.closeAll();
      if (this.state.selectedActivityId !== null) {
        // if (this.props.excludedCptCodes && !this.props.excludedCptCodes.length) {
        //   return showWarningMessage('All service codes has been added to this activity.');
        // } else {
        this.setState({ open: true, payerServiceCodeId: null, payerActivityServiceCodeId: null, payerServiceCodeName: null });
        // }
      } else {
        return showWarningMessage('Please select activity first');
      }
    };

    handleClose = () => {
      this.setState({ open: false, payerServiceCodeId: null, payerActivityServiceCodeId: null, payerServiceCodeName: null });
    };


    handleNewRequest = (input, selectedRecord) => {
      input.onChange(selectedRecord.value);
      this.setState({ selectedActivityId: selectedRecord.value, noteTypeId: this.props.masterAppointmentTypeForPayer.filter((xp)=>xp.id === selectedRecord.value)[0].noteTypeId }, () => {
        if (this.state.selectedActivityId)
          this.loadData();
      });
    };

    handleDeleteCptCodeConfirm = (e, id) => {
      this.props.deletePayerActivityCode(id);
      this.loadData();
      Alert.closeAll();
    };

    handleEditCptCode = (e, Obj) => {
      Alert.closeAll();
      this.setState({ open: true, payerServiceCodeId: Obj.payerServiceCodeId, payerActivityServiceCodeId: Obj.id, payerServiceCodeName: Obj.serviceCode, noteTypeId: Obj.noteTypeId });
    }

    handleDeleteCptCode=(event, obj) => {
      alertConfirmation('Please delete all sessions with this activity before deleting this service code. Are you sure you want to continue?', {
        customFields: {
          displayComponent: true,
          handleButtonClick: this.handleDeleteCptCodeConfirm,
          id: obj.id,
        },
      });
    };
    handleResetButton() {
      Alert.closeAll();
      this.filter.sort_Column = 'id';
      this.filter.sort_Order = 'desc';
      this.filter.searchText = '';
      this.props.dispatch(reset('PayerActivityServiceCodes'));
      this.loadData();
    };


    componentWillReceiveProps = (nextProps) => {
      if (nextProps.savedPayerActivityCode && this.props.savedPayerActivityCode !== nextProps.savedPayerActivityCode) {
        this.loadData();
      }
      if (nextProps.activitySaving) {
        this.loadData();
      }
      if (nextProps.payerCptCodesByActivity && this.props.payerCptCodesByActivity !== nextProps.payerCptCodesByActivity) {
        if (nextProps.payerCptCodesByActivity && nextProps.payerCptCodesByActivity.length) {
          this.setState({ meta_data_Activity_Cpt: nextProps.payerCptCodesByActivity.meta });
        }
      }
      if (nextProps.updatePayerAppointmentType && this.props.updatePayerAppointmentType !== nextProps.updatePayerAppointmentType) {
        this.loadData();
      }
      if (nextProps.deletePayerActivityCodes && this.props.deletePayerActivityCodes !== nextProps.deletePayerActivityCodes) {
        this.loadData();
      }
      if (nextProps.updateCodeModifier && this.props.updateCodeModifier !== nextProps.updateCodeModifier) {
        this.loadData();
      }
    };

    handleSearchChange(event) {
      if (event.target.value.length === 0) {
        this.filter.searchText = '';
        this.loadData();
      }
      if (event.target.value && event.target.value.length >= 3) {
        this.filter.searchText = event.target.value;
        this.loadData();
      }
    }

    setSortColumn(col_name, col_order) {
      if (col_name) {
        this.filter.sort_Column = col_name;
        this.filter.sort_Order = col_order;
        this.loadData();
      }
    }

    handleFormSubmit = (formData) => {
      formData.isActive = false;
    };

    handleAddActivity = () => {

      // if (this.props.masterActivityType) {

      //   console.log('masterActivityType-------', this.props.masterActivityType);
      // }


      // if (this.props.masterAppointmentTypeForPayer) {
      //   this.setState({ newActivityList: this.props.masterAppointmentTypeForPayer }, () => {
      //     // if (this.props.payerAllActivities.length) {
      //     this.setState({ isNewActivity: true, isFormNew: true });

      //   });
      // }

    };

    handleEditActivity = (e, data) => {
      this.props.dispatch(change('PayerActivityServiceCodes', 'activityName', data.appointmentTypeID));
      this.setState({ isNewActivity: !this.state.isNewActivity, isFormNew: false, selectedActivity: data.appointmentTypeID }, () => {
        this.loadData();
      });
    };

    handleFilterActivity = () => {
      this.filter.searchText = this.props.activityNameText;
      this.loadData();
    };

    handleResetActivity = () => {
      this.props.dispatch(change('PayerActivityServiceCodes', 'activityNameText', ''));
      this.props.dispatch(change('PayerActivityServiceCodes', 'IsActiveActivity', ''));
      this.filter.searchText = '';
      this.loadData();
    };

    handleCancelActivity = () => {
      this.props.backToActivitiesPage();
    };

    renderPayerCptCodesByActivityData() {
      if (!this.props.activityServiceCodes || !this.props.activityServiceCodes.length) {
        return (
          <tr>
            <td colSpan="8" className="text-center no-record">No record found.</td>
          </tr>
        );
      }

      if (this.props.activityServiceCodes && this.props.activityServiceCodes.length > 0) {
        return this.props.activityServiceCodes.map((Obj, index) => {
          return (
            <tr key={index}>
              <td>{Obj.serviceCode}</td>
              <td>{Obj.attachedModifiers}</td>
              <td>
                {Obj.description && Obj.description.length > 0 ?
                  <Tooltip Description={Obj.description} />
                  : null}
                {Obj.description != null && Obj.description.length > 20 ? SubString(Obj.description, 20) : Obj.description != null ? Obj.description : 'N/A'}
              </td>              
              <td>{Obj.unitDuration} {Obj.unitTypeName}</td>
              <td>{showNormalizedRate(Obj.ratePerUnit)}</td>
              <td className = {Obj.isBillable === true ? 'greenfont' : 'redfont'}>{Obj.isBillable === true ? 'Yes' : 'No'}</td>
              <td className={Obj.isRequiredAuthorization === true ? 'greenfont' : 'redfont'}>{Obj.isRequiredAuthorization === true ? 'Yes' : 'No'}</td>
              <td>
                <button onClick={(e) => this.handleEditCptCode(e, Obj)} type="button" title="Edit" className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>
                <button onClick={(e) => this.handleDeleteCptCode(e, Obj)} type="button" title="Delete" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>
              </td>
            </tr>
          );
        });
      }
    }

    render() {
      // const { handleSubmit } = this.props;
      const tableClass = classNames({
        'table': true,
        'table-striped': this.props.condensed,
        'table-bordered': this.props.bordered,
        'table-hover': true,
        'table-condensed': this.props.condensed,
        'customtable': true,
      });
      return (
        <div>
          <div className="row">
            <div className="col-sm-8 filter_btns">
            { (  this.props.agencyName.toUpperCase() === VIP || this.props.agencyName.toUpperCase() === AMEGO || this.props.agencyName.toUpperCase() === AMEGOFL ||  this.props.agencyName.toUpperCase() === IAT ||  this.props.agencyName.toUpperCase() === TIIBA || this.props.agencyName.toUpperCase() === CWO || this.props.agencyName.toUpperCase() === ADAMANTSERVICES || this.props.agencyName.toUpperCase() === SOAR || this.props.agencyName.toUpperCase().startsWith(EBS) || this.props.agencyName.toUpperCase() === 'ALLTOGETHERABA' || this.props.agencyName.toUpperCase() === 'ADAPTIVEPATH' || (!this.props.activityServiceCodes || !this.props.activityServiceCodes.length)  && this.state.selectedActivityId !== null) ?
              <RaisedButton
                primary={true}
                onTouchTap={this.handleOpen}
                title="Add service codes for this activity"
                label="Add Service Code">
              </RaisedButton>
              :null}              
              {this.state.open ?
                <ActivityServiceCodeModal payerId={this.props.payerId} selectedActivityId={this.state.selectedActivityId} payerServiceCodeName={this.state.payerServiceCodeName} payerServiceCodeId={this.state.payerServiceCodeId} payerActivityServiceCodeId={this.state.payerActivityServiceCodeId} excludedCptCodes={this.props.excludedCptCodes} closeDialog={this.handleClose} noteTypeId={this.props.noteTypeId || this.state.noteTypeId} />
                : null}
            </div>
            <div className="col-sm-4 require activityname">
              <Field
                name="activityName"
                label="Activity Name"
                options={this.props.masterAppointmentTypeForPayer || []}
                handleNewRequest={this.handleNewRequest}
                component={renderAutoCompleteSingleSelectForColor}
              />
            </div>
          </div>
          {!this.state.selectedActivityId ?
            (
              <div className="row">
                <div className="col-sm-12">
                  <div className="familydl text-center no-record">
                      No Activity Selected.
                  </div>
                </div>
              </div>
            )
            :
            (<div className="table-responsive mt-20">
              <table className={tableClass}>
                <thead>
                <tr>
                    <th width="14%"><SortingCustom setSortColumn={this.setSortColumn} columnName='cptCode' displayName='Service Code'/></th>
                    <th width="12%">Modifiers</th>
                    <th width="20%"><SortingCustom setSortColumn={this.setSortColumn} columnName='description' displayName='Description'/></th>
                    <th width="15%"><SortingCustom setSortColumn={this.setSortColumn} columnName='unitDuration' displayName='Unit Duration'/></th>
                    <th width="11%"><SortingCustom setSortColumn={this.setSortColumn} columnName='ratePerUnit' displayName='Rate($)'/></th>
                    <th width="9%">Billable</th>
                    <th width="10%">Req. Auth.</th>
                    <th width="9%">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {this.renderPayerCptCodesByActivityData()}
                </tbody>
              </table>
              {this.props.metaData && this.props.metaData.totalPages ?
                <PaginatorCustom data={this.props.metaData} handlePageChange={(page_number) => this.loadData(page_number)} />
                : null
              }
            </div>)}
          <div>
            <div className="col-sm-12 pt20 btn_rt">
              <RaisedButton
                primary={true}
                className="ml_15"
                onTouchTap={this.handleCancelActivity} label="Back"></RaisedButton>
            </div>
          </div>
        </div>
      );
    }
}

const selector = formValueSelector('PayerActivityServiceCodes'); // <-- same as form name

PayerActivityServiceCodes = reduxForm({
  form: 'PayerActivityServiceCodesForm',
  validate,
})(PayerActivityServiceCodes);

function mapStateToProps(state, ownProps) {

  let activityServiceCodes = [], masterAppointmentTypeForPayer = [], metaData = null, excludedCptCodes = [], inintialValueData = [];
  if (ownProps.payerActivityId) {
    inintialValueData = {
      activityName: ownProps.payerActivityId,
    };
  }
  if (state.payer.activity_service_codes && state.payer.activity_service_codes.data) {
    activityServiceCodes = state.payer.activity_service_codes.data;
    metaData = state.payer.activity_service_codes.meta;
  }
  if (state.payer.excluded_cpt_codes && state.payer.excluded_cpt_codes.data) {
    excludedCptCodes = state.payer.excluded_cpt_codes.data;
  }
  if (state.payer.activity_for_payer && state.payer.activity_for_payer.data) {
    masterAppointmentTypeForPayer = state.payer.activity_for_payer.data;
  }
  // console.log('activityServiceCodes......',activityServiceCodes && activityServiceCodes[0] ? activityServiceCodes[0].noteTypeId : null)
  // state.payer.masterAppointmentTypeForPayer, excludedCptCodes);
  return {
    masterAppointmentTypeForPayer: masterAppointmentTypeForPayer,
    activityServiceCodes: activityServiceCodes,
    noteTypeId: activityServiceCodes && activityServiceCodes[0] ? activityServiceCodes[0].noteTypeId : null,
    metaData: metaData,
    initialValues: inintialValueData,
    deletePayerActivityCodes: state.payer.deletePayerActivityCode,
    excludedCptCodes: excludedCptCodes,
    savedPayerActivityCode: state.payer.saveActivityCode,
    updateCodeModifier: state.payer.updateCodeModifier,
    activityName: selector(state, 'activityName'),
    activityNameText: selector(state, 'activityNameText'),
    isActive: selector(state, 'isActive'),
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
  };
}

export default connect(mapStateToProps, { getAppointmentTypeForPayer, getPayerActivityCptCodes, getExcludedServiceCodesFromActivity, deletePayerActivityCode,
})(PayerActivityServiceCodes);




// WEBPACK FOOTER //
// ./src/modules/Payers/containers/payerModule/payerActivityServiceCodes.js